(function($){
	"use strict";

	function openTab(tabSlug) {
		var $topProduct = $('#site-main > .container > .product'),
			$topProductTabs = $('#site-main > .container > .product > .woocommerce-tabs');
		$topProductTabs.find('> .woocommerce-Tabs-panel').hide();
		$topProductTabs.find('> .woocommerce-Tabs-panel--'+tabSlug).show();
		$topProductTabs.find('> .tabs li').removeClass('active');
		$topProductTabs.find('> .tabs li#tab-title-'+tabSlug).addClass('active');
	}

	function initExamPrepBookStudyMode() {
		if (!$('body.page-template-page-book-study-mode').length &&
			!$('body.page-template-page-question-tag-mode').length) return;


		if (!getCookie('2018_popup_show')) {
			$('#2018_popup').modal('show');
			setCookie('2018_popup_show', 1);
		}

		$('.show-explanation-btn').on('click', function(e) {
			$(this).hide();
			$(this).parent().parent().find('.explanation').show();
		});

		$('.answer button').on('click', function(e) {
			//console.log(this, $(this).parent('.answers'), $(this).parent('.answers').find('.answer button .icon'));
			$(this).parent().parent().find('.answer button .icon').html('<i class="fas fa-times-circle"></i>');
			$(this).parent().parent().find('.answer button[data-correct] .icon').html('<i class="fas fa-check-circle"></i>');
			$(this).parent().parent().parent().find('.show-explanation-btn').hide();
			$(this).parent().parent().parent().find('.explanation').show();
			if ($(this).attr('data-correct') == 'true') {
				$(this).find('.icon').addClass('correct-answer');
			} else {
				$(this).find('.icon').addClass('incorrect-answer');
			}
		});
	}

	function initFlashCardStudyMode() {
		if (!$('body.page-template-page-flash-card-mode').length) return;


		if (!getCookie('2018_popup_show')) {
			$('#2018_popup').modal('show');
			setCookie('2018_popup_show', 1);
		}

		$(document.body).on('click', '.question .answers button', function(e) {
			e.preventDefault();

			if ($(this).attr('data-correct') == 'true') {
				$('.question .answer-label').html('You chose the correct answer:');
			} else {
				$('.question .answer-label').html('Incorrect. The correct answer was:');
			}

			$('.question').addClass('flipped');
		});
		$(document.body).on('click', '.question .back', function(e) {

			//console.log(e.target);
			if ($(e.target).parents('.back-arrow').length) return;

			e.preventDefault();

			$('.question').removeClass('displayed');

			setTimeout(function(e) {
				pullFlashCard();
				$('.question').addClass('displayed');
			}, 500);

		});
		$(document.body).on('click', '.question .back-arrow', function(e) {
			e.preventDefault();
			$('.question').removeClass('flipped');
		});

		pullFlashCard();
	}

	function pullFlashCard() {
		var question = questions_json.splice(Math.floor(Math.random()*questions_json.length), 1);

		displayFlashCard(question[0]);
	}

	function displayFlashCard(question) {
		var answers_markup = '',
			correct_answer_markup = '',
			explanation_markup = '<div class="answer-explanation"><p>Explanation:</p><div class="explanation-text">'+question.explanation.replace(/(\r\n|\n|\r)/g,"<br />")+'</div></div>';
		for (var i in question.answers) {
			if (i == question.correct_answer) {
				correct_answer_markup = '<div class="correct-answer"><div class="nav-arrow back-arrow"><i class="fas fa-arrow-left"></i><span class="arrow-text"> Back</span></div><div class="nav-arrow next-arrow"><span class="arrow-text">Next </span><i class="fas fa-arrow-right"></i></div><p class="answer-label">Correct Answer:</p><p style="font-size: 1.8rem;color: green;">' + question.answers[i] + '</p></div>';
				answers_markup += '<div class="answer"><button id="answer-'+i+'" name="answer-'+i+'" data-correct="true">'+question.answers[i]+'</button></div>';
			} else
				answers_markup += '<div class="answer"><button id="answer-'+i+'" name="answer-'+i+'">'+question.answers[i]+'</button></div>';
		}

		var question_markup = '<div class="question"><div class="front"><h3 class="query">'+question.query+'</h3><div class="answers">'+answers_markup+'</div></div><div class="back"><div class="back-inner">'+correct_answer_markup+'<hr>'+explanation_markup+'<button id="next-question">Next Question</button></div></div></div>';
		//console.log(question_markup);

		$('.test-questions').empty().append(question_markup);
		setTimeout(function() {
			$('.question').addClass('displayed');

			setTimeout(function() {
				if ($('.flash-cards .question .back-inner').outerHeight() > $('.flash-cards .question').outerHeight()) {
					$('.flash-cards .question').height($('.flash-cards .question .back-inner').outerHeight() + 100);
				}
			}, 500);

		},1);
	}

	function initChapterTestMode() {
		if (!$('body.page-template-page-chapter-test-mode').length) return;


		if (!getCookie('2018_popup_show')) {
			$('#2018_popup').modal('show');
			setCookie('2018_popup_show', 1);
		}

		var correct_count = 0,
			answered_count = 0,
			total_count = $('.test-questions .question').length;

		$('.show-explanation-btn').on('click', function(e) {
			$(this).hide();
			$(this).parent().parent().find('.explanation').show();
		});

		$('.answer button').on('click', function(e) {
			$(this).parent().parent().find('.answer button .icon').html('<i class="fas fa-circle"></i>');
			$(this).find('.icon').html('<i class="fas fa-check-circle"></i>');
			//$(this).attr

			if ($(this).attr('data-correct') == 'true') {
				$(this).parents('.question').attr('data-correct', 'true');
			} else {
				$(this).parents('.question').attr('data-correct', 'false');
			}
		});

		$('#submit-test').on('click', function(e) {
			$('.test-questions .question[data-correct=true]').each(function(e) {
				correct_count++;
				answered_count++;
			});
			$('.test-questions .question[data-correct=false]').each(function(e) {
				answered_count++;
			});

			// display results
			var percent_right = (correct_count / total_count) * 100,
				recommendation_markup = '';
			if (percent_right >= 75) {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Passed',
					'module': 'Chapter Test Mode',
					'codebook': user_data.codebook,
					'chapter': user_data.chapter,
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions from this chapter to pass this section of your exam!  However, we recommend our students consistently shoot for a 90% score before taking the test.</span>';
			} else if (percent_right >= 90) {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Passed',
					'module': 'Chapter Test Mode',
					'codebook': user_data.codebook,
					'chapter': user_data.chapter,
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions from this chapter to pass this section of your exam!  You are ready to ace this chapter.</span>';
			} else {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Failed',
					'module': 'Chapter Test Mode',
					'codebook': user_data.codebook,
					'chapter': user_data.chapter,
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: red;">You need to score at least 75% to pass this section of your exam.  We recommend you continue to study this chapter until you hit 90%</span><br/><br /><a href="javascript:location.reload();" style="font-size:24px;">Click Here To Try Again</a><br /><br />';
			}
			var results_markup = '<div id="test-results"><p>With '+correct_count+' out of '+total_count+' questions correct, you\'ve scored a <strong>'+percent_right.toFixed(2)+'%</strong></p><p>'+recommendation_markup+'</p></div>';
			$('.entry-content').empty().html(results_markup);
			$('.test-questions .question[data-correct=true], .instruction-wrap').hide();
			$('.test-questions .question .explanation').show();
			$('.answer button').addClass('show-red');
			$('.answer button[data-correct=true]').removeClass('show-red').addClass('show-green');
			$('.chapter-submit').hide();
			$('.chapter-nav').show();
		});
	}

	function initExamSimMode() {
		if (!$('body.page-template-page-exam-sim-mode').length) return;


		if (!getCookie('2018_popup_show')) {
			$('#2018_popup').modal('show');
			setCookie('2018_popup_show', 1);
		}

		var correct_count = 0,
			answered_count = 0,
			total_count = $('.test-questions .question').length;

		var show_answered_qs = true;
		$('#q-showtoggle').on('click', function(e) {
			if (show_answered_qs) {
				console.log('hide qs');
				show_answered_qs = false;
				$('.question[data-correct]').hide();
				$('#q-showtoggle').html('Hiding Completed Questions');
			} else {
				console.log('show qs');
				show_answered_qs = true;
				$('.question[data-correct]').show();
				$('#q-showtoggle').html('Showing Completed Questions');
			}
		});

		$('.answer button').on('click', function(e) {
			$(this).parent().parent().find('.answer button .icon').html('<i class="fas fa-circle"></i>');
			$(this).find('.icon').html('<i class="fas fa-check-circle"></i>');
			//$(this).attr

			if ($(this).attr('data-correct') == 'true') {
				$(this).parents('.question').attr('data-correct', 'true');
			} else {
				$(this).parents('.question').attr('data-correct', 'false');
			}
			//var $answeredQuestion = $(this).parent().parent().parent();
			//$answeredQuestion.addClass('answered');
			//setTimeout(function() {
			//	$answeredQuestion.slideUp();
			//}, 100);
			if (show_answered_qs) {
				console.log('show');
				//$(this).show();
			} else {
				console.log('slide');
				$(this).parent().parent().parent().slideUp();
			}

		});

		$('.question .mark-for-review').on('click', function(e) {
			var $this = $(this);

			if ($this.hasClass('do-review')) {
				//$this.removeClass('do-review').addClass('do-not-review');
				//$this.html('<i class="fas fa-times-circle"></i></span> This question will not be reviewed after the exam.');
			} else {
				$this.removeClass('ask-to-review').removeClass('do-not-review').addClass('do-review');
				$this.html('<i class="fas fa-check-circle"></i></span> This question was postponed but must be answered before submitting the exam.');
				$this.parent().appendTo('.test-questions');
			}
		});

		$('#submit-test').on('click', function(e) {
			correct_count = 0;
			answered_count = 0;

			$('.test-questions .question[data-correct=true]').each(function(e) {
				correct_count++;
				answered_count++;
			});
			$('.test-questions .question[data-correct=false]').each(function(e) {
				answered_count++;
			});

			console.log(correct_count, answered_count);
			if (answered_count < total_count) {
				var results_markup = '<div id="test-results"><p class="results-text"><span style="color:red">You must answer all questions before submitting your exam.</span></p></div>';
				$('.entry-content').empty().html(results_markup);

				window.scrollTo(0,0);
				return;
			}

			// display results
			var percent_right = (correct_count / total_count) * 100,
				recommendation_markup = '';
			if (percent_right >= 75) {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Passed',
					'module': 'Exam Sim Mode',
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions to pass your of your exam!  However, we recommend our students consistently shoot for a 90% score before taking the test.</span>';
			} else if (percent_right >= 90) {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Passed',
					'module': 'Exam Sim Mode',
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions to pass your exam!  You are ready to ace the test.</span>';
			} else {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Failed',
					'module': 'Exam Sim Mode',
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: red;">You need to score at least 75% to pass your exam.  We recommend you continue to study until you hit 90%</span>';
			}
			var results_markup = '<div id="test-results"><p class="results-text">With '+correct_count+' out of '+total_count+' questions correct, you\'ve scored a <strong>'+percent_right.toFixed(2)+'%</strong></p><p>'+recommendation_markup+'</p></div>';
			$('.entry-content').empty().html(results_markup);
			//$('.test-questions .question[data-correct=true], .instruction-wrap').hide();
			$('.test-questions .question .explanation').show();
			$('.answer button').addClass('show-red');
			$('.answer button[data-correct=true]').removeClass('show-red').addClass('show-green');
			$('.chapter-submit').hide();

			window.scrollTo(0,0);

			/*
			$('.do-review').parent().removeClass('answered').show().find('.explanation').show();

			var $correctQuestions = $('.question[data-correct="true"]');
			$correctQuestions.css('background-color', '#D7FFE3').find('.query').prepend('<span style="color: green">CORRECT</span><br/><br/>');
			$correctQuestions.find('.mark-for-review').hide();

			var $incorrectQuestions = $('.question[data-correct="false"]');
			$incorrectQuestions.css('background-color', '#FCE5E5').find('.query').prepend('<span style="color: red">INCORRECT</span><br/><br/>');
			$incorrectQuestions.find('.mark-for-review').hide();

			 */

			$('.timer').hide();


			clearTimeout(exam_timer);
		});

		var time_limit = parseInt($('.timer').attr('data-time-allowed'));
		if (parseInt(user_data.extended_time_50) == 1)
			time_limit += (time_limit/2);
		var exam_timer = setInterval(function(e) {
			time_limit = time_limit - 1;

			// calculate and update timer
			var date = new Date(null);
			date.setSeconds(time_limit); // specify value for SECONDS here
			var result = date.toISOString().substr(11, 8);
			$('.timer').html(result);

			if (time_limit == 0) {
				clearTimeout(exam_timer);

				$('.test-questions .question[data-correct=true]').each(function(e) {
					correct_count++;
				});

				// display results
				var percent_right = (correct_count / total_count) * 100,
					recommendation_markup = '';
				if (percent_right >= 75) {
					tlc_log_action({
						'exam':   user_data.exam,
						'action': 'Timeout',
						'module': 'Exam Sim Mode',
						'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
						'url':    window.location.href
					});
					recommendation_markup = '<span style="color: green;">You\'ve run out of time, but you\'ve correctly answered enough questions to pass your of your exam!  However, we recommend our students consistently shoot for a 90% score before taking the test.</span>';
				} else if (percent_right >= 90) {
					tlc_log_action({
						'exam':   user_data.exam,
						'action': 'Timeout',
						'module': 'Exam Sim Mode',
						'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
						'url':    window.location.href
					});
					recommendation_markup = '<span style="color: green;">You\'ve run out of time, but you\'ve correctly answered enough questions to pass your exam!  You are ready to ace the test.</span>';
				} else {
					tlc_log_action({
						'exam':   user_data.exam,
						'action': 'Timeout',
						'module': 'Exam Sim Mode',
						'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
						'url':    window.location.href
					});
					recommendation_markup = '<span style="color: red;">You\'ve run out of time, and need to score at least 75% to pass your exam.  We recommend you continue to until you hit 90%</span>';
				}
				var results_markup = '<div id="test-results"><p class="results-text">With '+correct_count+' out of '+total_count+' questions correct, you\'ve scored a <strong>'+percent_right.toFixed(2)+'%</strong></p><p>'+recommendation_markup+'</p></div>';
				$('.entry-content').empty().html(results_markup);
				$('.test-questions .question[data-correct=true], .instruction-wrap').hide();
				$('.test-questions .question .explanation').show();
				$('.answer button').addClass('show-red');
				$('.answer button[data-correct=true]').removeClass('show-red').addClass('show-green');
				$('.chapter-submit').hide();

				window.scrollTo(0,0);
			}
		}, 1000);
	}

	function initExamPrepPage() {
		if (!$('body.page-template-page-exam-prep').length) return;

		if (!getCookie('2018_popup_show')) {
			$('#2018_popup').modal('show');
			setCookie('2018_popup_show', 1);
		}

		$('.exam-prep-link button').on('click', function(e) {
			e.preventDefault();
			//console.log('test');

			if ($(this).parent().attr('data-store-url')) {
				location.href = $(this).parent().attr('data-store-url');
				return;
			}
			if ($(this).parent().attr('data-enrolled') == 'true') {
				$(this).parent().find('.mode-links')
					.slideDown();
				return;
			}
		});

		if (user_data.programs.m1_2024) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2024-m1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.m2_2024) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2024-m2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.b1_2024) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2024-b1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.b2_2024) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2024-b2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.p1_2024) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2024-p1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.b1_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-b1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.b2_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-b2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.e1_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-e1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.e2_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-e2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.m1_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-m1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.m2_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-m2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.p1_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-p1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.p2_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-p2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.fg_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-fg"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.commercial_energy_inspector_2021) {
			$('#all-2021-courses').show();
			var $course = $('.exam-prep-link[data-course="2021-commercial-energy-inspector"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.b1_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-b1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.b2_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-b2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.m1_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-m1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.m2_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-m2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.p1_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-p1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.p2_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-p2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.e1_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-e1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.e2_2018) {
			$('#all-2018-courses').show();
			var $course = $('.exam-prep-link[data-course="2018-e2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.b1_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="b1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.b2_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="b2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.m1_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="m1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.m2_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="m2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.p1_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="p1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.p2_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="p2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.e1_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="e1"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.e2_2015) {
			$('#all-2015-courses').show();
			var $course = $('.exam-prep-link[data-course="e2"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f11) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f11"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f12) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f12"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f13) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f13"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f16) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f16"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f17) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f17"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f18) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f18"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f24) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f24"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f25) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f25"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f27) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f27"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f28) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f28"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f29) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f29"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f31) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f31"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f32) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f32"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.f49) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="f49"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g11) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g11"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g12) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g12"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g13) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g13"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g16) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g16"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g17) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g17"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g18) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g18"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g24) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g24"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g25) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g25"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g27) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g27"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g28) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g28"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g29) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g29"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.g31) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="g31"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.t16) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="t16"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.t17) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="t17"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.t18) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="t18"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kga) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kga"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kgb) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kgb"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kgc) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kgc"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kgl) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kgl"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kgx) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kgx"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kgh) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kgh"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kgd) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kgd"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_550) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_550"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_551) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_551"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_552) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_552"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_554) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_554"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_556) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_556"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_557) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_557"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_558) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_558"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_559) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_559"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_560) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_560"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kansas_565) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kansas_565"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kentucky_701) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kentucky_701"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.kentucky_703) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="kentucky_703"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.missouri_w16) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="missouri_w16"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.missouri_w17) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="missouri_w17"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.missouri_w24) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="missouri_w24"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.missouri_w25) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="missouri_w25"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.missouri_w29) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="missouri_w29"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.missouri_w31) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="missouri_w31"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.pennsylvania_211) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="pennsylvania_211"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.south_dakota_530) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="south_dakota_530"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.south_dakota_531) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="south_dakota_531"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.south_dakota_533) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="south_dakota_533"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wyoming_385) {
			$('#all-contractor-courses').show();
			var $course = $('.exam-prep-link[data-course="wyoming_385"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
	}

	function initCompanyDashboardPage() {
		if (!$('body.page-template-page-company-dashboard').length) return;

		if ($('#cont-ed-lessons').length && isDesktop() && typeof StickySidebar != 'undefined')
			var contEdLessonsSidebar = new StickySidebar('#cont-ed-lessons .sticky-container', {topSpacing: 47});


		$('#back-to-dash').on('click', function(e) {
			$('#company-intro').show();
			$('#student-data').hide();
			window.scrollTo(0,0);
			currentStudentID = false;
		});


		var currentStudentID = false;
		$('.available-lessons-box li a, .completed-lessons-box li a, .recommended-lessons-box li a, .unenrolled-lessons-box li a, .overdue-lessons-box li a, .no_due_date-lessons-box li a, .cert-prep-lessons-box li a, .students-due-box a').on('click', function(e) {
			$('#company-intro').hide();
			$('#student-data').show();

			var studentId = $(this).attr('data-student');
			currentStudentID = studentId;
			$('.current-lesson').removeClass('current-lesson');
			$('a[data-student="'+studentId+'"]').parent().addClass('current-lesson');

			var student = companyStudents[studentId];
			//console.log(student);

			regDate = false;
			if (student.user_registered != "0000-00-00 00:00:00") {
				var regDate = new Date(student.user_registered);
				var ampm = 'AM';
				var regHours = regDate.getHours() + 1;
				if (regHours > 12) {
					regHours = regHours - 12;
					ampm = 'PM';
				}
				var regDateStr = (regDate.getMonth() + 1) + '/' + regDate.getDate() + '/' + regDate.getFullYear() + ' at ' + regHours + ':' + ("0" + regDate.getMinutes()).slice(-2) + ' ' + ampm;
				$('#student-joined').html(regDateStr);
				$('.student-joined').show();
			} else {
				$('#student-joined').html('No record.');
				$('.student-joined').hide();
			}




			$('#student-name').html(student.display_name);
			$('#student-email').html(student.user_email);


				$('#student-cert-prep-data').show();


			if (student.actions_log && student.actions_log.length)
				$('#student-log').html(student.actions_log);
			else
				$('#student-log').html("This student has not viewed any material nor taken any actions.");

			if (student.last_action) {
				$('.student-last-action').show();
				$('#student-last-action').html(student.last_action);
			} else {
				$('.student-last-action').hide();
			}


			if (!student.cert_prep_log || student.cert_prep_log.length == 0 || student.cert_prep_log == "")
				$('#student-cert-prep-table').html('<tr><td colspan="3">This student has not yet taken any actions.</td></tr>');
			else {
				var _cp_table = '';
				for (var i in student.cert_prep_log) {
					_cp_table += '<tr><td>'+student.cert_prep_log[i][2]+'</td><td>'+student.cert_prep_log[i][3]+'</td><td>'+student.cert_prep_log[i][4]+'</td><td>'+student.cert_prep_log[i][5]+'</td><td>'+student.cert_prep_log[i][6].replace('chapter-','')+'</td><td sorttable_customkey="'+student.cert_prep_log[i][0]+'">'+student.cert_prep_log[i][1]+'</td></tr>';
				}
				$('#student-cert-prep-table').html(_cp_table);
				sorttable.makeSortable(jQuery('.student-cert-prep-log').get(0));
			}

			window.scrollTo(0,0);
		});
	}

	jQuery(function($) {

		initExamPrepPage();
		initExamPrepBookStudyMode();
		initFlashCardStudyMode();
		initChapterTestMode();
		initExamSimMode();
		initCompanyDashboardPage();

		/*
		if ($('.mike-design').length) {
			$('.glide__slides').append(
`
<li className="glide__slide">
	<div class="product-testimonial">
		<div class="testimonial-head"></div>
			<p class="testimonial-link"><a href="https://www.bbb.org/us/ca/novato/profile/training-program/thompson-learning-inc-1116-75957/customer-reviews" target="_blank">SOURCE - BBB</a></p>
			<h5>Testimonial</h5>
		</div>
		<div class="testimonial-author">
			<img src="https://passiccexam.com/wp-content/themes/passrbiexam/assets/images/misc/profile-test.png" />
			<p class="author-name">Jason C.</p>
			<div class="author-rating"><img src="https://passiccexam.com/wp-content/themes/passrbiexam/assets/images/misc/five-stars.png" /></div>
		</div>
		<div class="testimonial-body">
			<p>These courses were instrumental in helping me to achieve my goal of becoming a fully certified building inspector. I was originally using another company and failed my residential electrical exam. Thats when I found Thompson Learning, after using their exam prep I passed on my next attempt as well as passing on the first attempt for the next 4 commercial certifications. I used the exam prep as directed and I am very happy with the results. I highly recommend this program.</p>
		</div>
	</div>
</li>
`);

			new Glide('.glide').mount();
		}

		 */

		//$('.description_tab').click();

		$('#site-main > .container > .product > .woocommerce-tabs > ul > li > a').on('click', function () {
			//console.log('r');
			//$('.panel .description_tab a').click();
			setTimeout(function () {
				$('.woocommerce-tabs .woocommerce-tabs .woocommerce-Tabs-panel').hide();
				$('.woocommerce-tabs .woocommerce-tabs .woocommerce-Tabs-panel--description').show();
				$('.woocommerce-tabs .woocommerce-tabs .tabs li').removeClass('active');
				$('.woocommerce-tabs .woocommerce-tabs .tabs li.description_tab').addClass('active');
			}, 10);
		});

		$('button.product-column-teaser-read-more-btn').on('click', function (e) {

			$(this).parents('.product-row').find('.product-row-full-text').slideToggle();
			$(this).addClass('section-open');

		});


		$('body').on('added_to_cart', function () {

			console.log('product added');
		});

		$('[data-toggle="tooltip"]').tooltip();

		$('a[href="/our-courses"], a[href="/our-courses/"]').on('click', function (e) {
			e.preventDefault();
			$('.expanded-navigation').addClass('visible');
			setTimeout(function () {
				document.getElementById('all-courses-menu').scrollIntoView();
			}, 400);
		});
		$('.exam-btn').on('click', function (e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function (i) {
				if ($(this).attr('href').indexOf('#practice-quiz') == -1)
					$(this).attr('href', $(this).attr('href') + '#practice-quiz');
			});
			$('#all-courses .call-to-action').html('Select a trade to take a free test or call today for a free consultation: <a href="tel:8666858564">1-866-685-8564</a>');

			$('.expanded-navigation').addClass('visible');
			setTimeout(function () {
				document.getElementById('all-courses-menu').scrollIntoView();
			}, 400);
		});
		$('.expand-courses-menu a').on('click', function (e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function (i) {
				$(this).attr('href', $(this).attr('href').replace('#practice-quiz', ''));
			});
			$('#all-courses .call-to-action').html('Select a trade below or give us a call today for a free consultation: <a href="tel:8666858564">1-866-685-8564</a>');
			$('.expanded-navigation').toggleClass('visible');
		});
		$('.expanded-navigation .close').on('click', function (e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function (i) {
				$(this).attr('href', $(this).attr('href').replace('#practice-quiz', ''));
			});
			$('#all-courses .call-to-action').html('Select a trade below or give us a call today for a free consultation: <a href="tel:8666858564">1-866-685-8564</a>');
			$('.expanded-navigation').removeClass('visible');
		});

		if (window.location.hash) {
			var hashValue = window.location.hash.split('#');
			if (hashValue.length > 1) hashValue = hashValue[1];

			openTab(hashValue);
		}

		$('#clear_shopping_cart').on('click', function (e) {
			$('input').val('');
			e.preventDefault();
		});

		$('.cleanlogin-form-bottom').empty();


		if (typeof user_data != 'undefined') {
			//$('#site-navbar .classroom-login').html('<a href="/exam-prep">Online Study Center</a>');

			if (user_data.exam) {
				$('#site-navigation .add-exam a').each(function (e) {
					$(this).attr('href', $(this).attr('href') + '?exam=' + user_data.exam);
				});
			}
		}
	});

	$('#scroll-to-products').click(function() {
		$('html, body').animate({
			scrollTop: $(".multiple-products").offset().top - 160
		}, 300);
		return false;
	});

	$('#saveCourseProgress').click(function() {
		console.log('Cookie Set: '+getCookie('tlcUserClassroomProgress'));
		var curUrl = window.location.href.split('#');
		curUrl = curUrl[0];
		var curUrlPlusScroll = curUrl + '#scroll='+$(document).scrollTop();
		setCookie('tlcUserClassroomProgress', curUrlPlusScroll);
	});
	$('#restoreCourseProgress').click(function() {
		var newUrl = getCookie('tlcUserClassroomProgress');
		if (newUrl.split('#scroll=')[0] == window.location.href.split('#scroll=')[0]) {
			console.log('Page Restore: '+getCookie('tlcUserClassroomProgress'));
			window.location.href = newUrl;
			window.location.reload();
		} else {
			console.log('Course Restore: '+getCookie('tlcUserClassroomProgress'));
			window.location.href = newUrl;
		}
	});

	const savedPageScroll = window.location.hash.split('#scroll=');
	if (savedPageScroll.length > 1 && parseInt(savedPageScroll[1]) > 0) {
		console.log('scrolling '+parseInt(savedPageScroll[1]));
		$('html, body').animate({
			scrollTop: parseInt(savedPageScroll[1]) // The target vertical scroll position in pixels
		}, 500);
	}


})(jQuery);

function tlc_log_action(postData) {

	if (typeof postData == 'undefined') return;

	postData.url = postData.url.replace('https://passiccexam.com/', '/');

	if (typeof postData.codebook == 'undefined') postData.codebook = '';
	if (typeof postData.chapter == 'undefined') postData.chapter = '';
	if (typeof postData.data == 'undefined') postData.data = '';
	if (typeof postData.exam == 'undefined')
		postData.exam = '';
	else
		postData.exam = postData.exam.toLowerCase();

	jQuery.post(ajax_params.ajax_url, {
		action: 'tlc_log_action',
		user_action: postData.action,
		module: postData.module,
		codebook: postData.codebook,
		chapter: postData.chapter,
		data: postData.data,
		exam: postData.exam,
		url: postData.url
	});

}

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	let expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}